import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as JobPipelineActions from '../../../store/job-pipeline/job-pipeline.actions';
import { NotificationService } from 'ui-components/services/notification-service';
import { messages } from '../messages';

export const ShowInitialNotificationStep = (state, jobId) => {
  const notificationId = NotificationService.showNotification({
    title: <FormattedMessage {...messages.printNotoTitle} />,
    notificationType: 'info',
    dontHide: true,
    content: <FormattedMessage {...messages.labelCheck} />,
  });
  return [JobPipelineActions.updateJob(jobId, { notificationId }), JobPipelineActions.goForwardOnJob(jobId)];
};
